<template>
  <div class="enroll-detail">
    Hi all
  </div>
</template>

<script>

export default {
  name: "enroll-detail",
  components: {
  },
  props: [],
  methods: {
  }
};
</script>

<style lang="scss" scoped>
</style>
